import axiosInstance from "./axiosInstance";
import { optimizeImageFormData } from "../utils/imageUpload";

export async function uploadFile(formData) {
  formData = await optimizeImageFormData(formData);
  return axiosInstance.post("/api/file/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteFile(url) {
  return axiosInstance.delete("/api/file", {
    params: { filename: url },
  });
}
